import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import LogoutModal from "../Modals/LogoutModal";
import { UseProvider } from "../hooks/useWeb3";
import { TiSocialAtCircular } from "react-icons/ti";
import { ImProfile } from "react-icons/im";


function Sidebar() {
    // modal
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);






    return (
        <>
            <div className="sidebar d-flex flex-column justify-content-between align-items-start">
                <div className="w-100">
                    <div className="sidebar_logo_holder px-4 py-3">
                        <img src={require('../assets/images/headerlogo.png')} className="img-fluid main_logo" />
                    </div>
                    <ul className="pt-4">
                        {/* <li className="mb-3">
                <NavLink to='/' className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                    <img src={require('../assets/images/grid.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Dashboard</p>
                </NavLink>
            </li> */}

                        <li className="mb-3">
                            <NavLink to='/launchpadlist' className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/1.png')} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Launchpad List</p>
                            </NavLink>
                        </li>

                        <li className="mb-3">
                            <NavLink to='/createLaunchpad' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/2.png')} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Create Launchpad</p>
                            </NavLink>
                        </li>

                        <li className="mb-3">
                            <NavLink to='/native-launchpad-list' className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/3.png')} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Native Launchpad List</p>
                            </NavLink>
                        </li>



                        

                        <li className="mb-3">
                            <NavLink to='/create-native-launchpad' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/4.png')} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Create Native Launchpad</p>
                            </NavLink>
                        </li>

                        <li className="mb-3">
                            <NavLink to='/tokenreqlist' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/5.png')} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Token Request List</p>
                            </NavLink>
                        </li>

                        <li className="mb-3">
                            <NavLink to='/allocationlist' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/6.png')} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Tier List</p>
                            </NavLink>
                        </li>

                        <li className="mb-3">
                            <NavLink to='/cmslist' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/7.png')} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">CMS List</p>
                            </NavLink>
                        </li>
                        <li className="mb-3">
                            <NavLink to='/faqlist' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/8.png')} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Faq List</p>
                            </NavLink>
                        </li>

                        <li className="mb-3">
                            <NavLink to='/interest-list' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/9.png')} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Interest List</p>
                            </NavLink>
                        </li>

                        {/* <li className="mb-3">
                            <NavLink to='/settings' className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/setting.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Settings</p>
                            </NavLink>
                        </li>

                        <li className="mb-3">
                            <NavLink to='/launchpadSettings' className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/network.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Launchpad Settings</p>
                            </NavLink>
                        </li>

                        <li className="mb-3">
                            <NavLink to='/feeSettings' className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/ticket.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Fee Settings</p>
                            </NavLink>
                        </li> */}
                        <li className="mb-3">
                            <NavLink to='/changePassword' className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/10.png')} className="img-fluid sidebar_linkImg" />
                               {/* <ImProfile/> */}
                                <p className="sidebar_link_hint">Profile Settings</p>
                            </NavLink>
                        </li>
                        {/* Register Account */}
                        {/* <li className="mb-3">
                            <NavLink to='/listRegisteraccount' className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/editer.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Register Account</p>
                            </NavLink>
                        </li>

                        <li className="mb-3">
                            <NavLink to='/listSprofeature' className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/editer.svg').default} className="img-fluid sidebar_linkImg" />
                                <p className="sidebar_link_hint">Spropad Features</p>
                            </NavLink>
                        </li> */}

                        <li className="mb-3">
                            <NavLink to='/listSocial' className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                                <img src={require('../assets/images/editer.svg').default} className="img-fluid sidebar_linkImg" />
                                {/* <TiSocialAtCircular/> */}
                                <p className="sidebar_link_hint">Social Link</p>
                            </NavLink>
                        </li>
                        {/* <li className="mb-3">
                <NavLink to='/subscription' className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                    <img src={require('../assets/images/prime.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Subscription</p>
                </NavLink>
            </li> */}


                    </ul>
                </div>

                <div className="w-100">
                    <li className="mb-3" onClick={handleShow}>
                        <div className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-3">
                            <img src={require('../assets/images/11.png')} className="img-fluid sidebar_linkImg" />
                            <p className="sidebar_link_hint">Logout</p>
                        </div>
                    </li>
                </div>

            </div>

            {/* modals */}
            <LogoutModal show={show} handleClose={handleClose} />
            {/* end of modals */}
        </>
    );
}

export default Sidebar;
